import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { UnifiedDataTable } from "../../../layout/unified-data-table/ui/unified-data-table";
import type { UnifiedTableRecord } from "../../../shared/ui/data-table/model/data-table-contract";

import * as Styled from "./vitals.styled";

interface IPatientInfoOutletContext {
  setIsStretchContent: React.Dispatch<React.SetStateAction<boolean>>;
}

const vitalsRecord: UnifiedTableRecord = {
  module: "vitals",
  pageTitle: "Vitals",
  sections: [
    {
      id: "vitals",
      title: "Vitals",
      tables: [
        {
          id: "vitals-table",
          columns: [
            { key: "date", header: "Date", sortable: true, width: 120 },
            { key: "temp", header: "Temp", sortable: true, width: 90 },
            { key: "pulse", header: "Pulse", sortable: true, width: 90 },
            {
              key: "peakFlow",
              header: "Peak Flow",
              sortable: true,
              width: 120,
            },
            { key: "pOx", header: "P.OX", sortable: true, width: 90 },
            { key: "resp", header: "Resp", sortable: true, width: 150 },
            { key: "bp", header: "BP", sortable: true, width: 260 },
            { key: "weight", header: "Weight", sortable: true, width: 110 },
            { key: "height", header: "Height", sortable: true, width: 100 },
            { key: "waist", header: "Waist", sortable: true, width: 90 },
            { key: "neck", header: "Neck", sortable: true, width: 90 },
            {
              key: "painLevel",
              header: "Pain Level",
              sortable: true,
              width: 120,
            },
            { key: "bmi", header: "BMI", sortable: true, width: 130 },
            { key: "bsa", header: "BSA", sortable: true, width: 110 },
            { key: "lmpDate", header: "LMP Date", sortable: true, width: 120 },
          ],
          rows: [
            {
              date: "01/27/2017",
              temp: "98.20",
              pulse: "74",
              peakFlow: "-",
              pOx: "-",
              resp: "18 (Unlabored)",
              bp: "50/84 (Sitting, Left Arm, Standard)",
              weight: "139.00 lb",
              height: "65 in",
              waist: "-",
              neck: "-",
              painLevel: "0",
              bmi: "23.13 kg/m2",
              bsa: "1.70 m2",
              lmpDate: "-",
            },
            {
              date: "01/27/2017",
              temp: "98.20",
              pulse: "74",
              peakFlow: "-",
              pOx: "-",
              resp: "18 (Unlabored)",
              bp: "50/84 (Sitting, Left Arm, Standard)",
              weight: "139.00 lb",
              height: "65 in",
              waist: "-",
              neck: "-",
              painLevel: "0",
              bmi: "23.13 kg/m2",
              bsa: "1.70 m2",
              lmpDate: "-",
            },
          ],
          ui: {
            searchable: true,
            searchPlaceholder: "Search...",
            searchKeys: [
              "date",
              "temp",
              "pulse",
              "peakFlow",
              "pOx",
              "resp",
              "bp",
              "weight",
              "height",
              "waist",
              "neck",
              "painLevel",
              "bmi",
              "bsa",
              "lmpDate",
            ],
            downloadable: ["csv", "xls", "pdf"],
            showTableDownloads: true,
            defaultRowsPerPage: 10,
            rowsPerPageOptions: [5, 10, 20, 25],
          },
        },
      ],
    },
  ],
};

export const Vitals = () => {
  const outletContext = useOutletContext<
    IPatientInfoOutletContext | undefined
  >();
  const setIsStretchContent = outletContext?.setIsStretchContent;
  const contentScrollerRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!setIsStretchContent) {
      return;
    }

    setIsStretchContent(true);

    return () => {
      setIsStretchContent(false);
    };
  }, [setIsStretchContent]);

  return (
    <Styled.Container>
      <Styled.Title>Vitals</Styled.Title>
      <UnifiedDataTable
        record={vitalsRecord}
        useSharedSectionNav
        scrollContainerRef={contentScrollerRef}
      />
    </Styled.Container>
  );
};
